// PortfolioItem
import React, { useState } from 'react';
import Icon from 'components/common/Icon';
import styles from './PortfolioItem.module.sass';
import cn from 'classnames';
import useOutsideClick from 'hooks/useOutsideClick';
import ImageKitImage from 'components/common/ImageKitImage';
import { CreatorProfileType } from 'types/profile';
import { MediaItem } from 'types/content';

export interface PortfolioItemProps {
  media: MediaItem;
  profileType: CreatorProfileType;
  onPreview: () => void;
  onEdit?: () => void;
  onRemove?: () => void;
  className?: string;
}

const PortfolioItem: React.FC<PortfolioItemProps> = ({
  media,
  profileType,
  onEdit,
  onPreview,
  onRemove,
  className,
}) => {
  const [showMenu, setShowMenu] = useState(false);

  const menuRef = useOutsideClick(() => {
    setShowMenu(false);
  });

  return (
    <div
      className={cn(styles.portfolioItem, className)}
      onClick={profileType !== 'personal' ? onPreview : undefined}
    >
      <div className={styles.itemContent}>
        <ImageKitImage path={media.url} videoPreview={media.type === 'video'} />
        <div
          className={cn(styles.portfolioOverlay, {
            [styles.hide]: profileType !== 'personal',
          })}
        >
          <span onClick={onEdit}>
            <Icon name="edit" size={20} />
          </span>
          <span onClick={onRemove}>
            <Icon name="trash" size={20} />
          </span>
          <span onClick={onPreview}>
            <Icon name="search" size={20} />
          </span>
        </div>
        {profileType === 'personal' && (
          <>
            <div
              className={styles.menuButton}
              onClick={() => setShowMenu(!showMenu)}
            >
              <Icon name="ellipsis" color="neutral04" />
            </div>
            <div
              ref={menuRef}
              className={cn(styles.editItemMenu, {
                [styles.hide]: !showMenu,
              })}
            >
              <div onClick={onPreview}>
                <Icon name="search" color="neutral04" />
                Preview Content
              </div>
              <div onClick={onEdit}>
                <Icon name="edit" color="neutral04" />
                Update Title
              </div>
              <div onClick={onRemove}>
                <Icon name="trash" color="neutral04" />
                Delete
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PortfolioItem;
